export const expertRegistration = {
  // Account Type Selection
  'expert.accountType.title': 'Bienvenue sur subvention360!',
  'expert.accountType.subtitle': 'Comment souhaitez-vous utiliser notre plateforme ?',
  'expert.accountType.user.title': 'Utilisateur',
  'expert.accountType.user.description': 'Je recherche des financements pour moi, mon entreprise ou mes clients',
  'expert.accountType.user.feature1': 'Recherche intelligente par IA',
  'expert.accountType.user.feature2': 'Recommandations personnalisées',
  'expert.accountType.user.feature3': 'Suivi de candidatures',
  'expert.accountType.user.cta': 'S\'inscrire comme utilisateur',
  
  'expert.accountType.expert.title': 'Annuaire conseiller',
  'expert.accountType.expert.description': 'Je souhaite être référencé sur la plateforme pour que de futurs clients puissent me trouver et que je puisse les aider',
  'expert.accountType.expert.feature1': 'Inscription gratuite',
  'expert.accountType.expert.feature2': 'Référencement dans notre annuaire',
  'expert.accountType.expert.feature3': 'Visibilité auprès des clients potentiels',
  'expert.accountType.expert.cta': 'S\'inscrire dans l\'annuaire conseiller',
  'expert.accountType.alreadyHaveAccount': 'Déjà inscrit ?',
  'expert.accountType.login': 'Se connecter',
  
  // Registration Wizard
  'expert.registration.title': 'Inscription Conseiller',
  'expert.registration.subtitle': 'Créez votre profil conseiller en quelques minutes',
  'expert.registration.step1': 'Entreprise',
  'expert.registration.step2': 'Expertise',
  'expert.registration.step3': 'Certifications',
  'expert.registration.step4': 'Géographie',
  'expert.registration.step5': 'Profil Pro',
  'expert.registration.step6': 'Récapitulatif',
  'expert.registration.step7': 'Compte',
  'expert.registration.next': 'Suivant',
  'expert.registration.previous': 'Précédent',
  'expert.registration.submit': 'Créer le compte',
  
  // Wizard UI
  'expertRegistration.wizard.title': 'Inscription Conseiller',
  'expertRegistration.wizard.subtitle': 'Rejoignez notre annuaire de conseillers en subventions',
  'expertRegistration.wizard.progress': 'Étape {{current}} sur {{total}}',
  'expertRegistration.steps.company': 'Entreprise',
  'expertRegistration.steps.expertise': 'Expertise',
  'expertRegistration.steps.certifications': 'Certifications',
  'expertRegistration.steps.geographic': 'Géographie',
  'expertRegistration.steps.profile': 'Profil',
  'expertRegistration.steps.summary': 'Révision',
  'expertRegistration.steps.auth': 'Compte',
  'expertRegistration.buttons.continue': 'Continuer',
  'expertRegistration.buttons.back': 'Retour',
  'expertRegistration.buttons.submit': 'Créer le compte',
  'expertRegistration.buttons.add': 'Ajouter',
  
  // Field labels
  'expertRegistration.fields.email': 'Adresse email',
  'expertRegistration.fields.password': 'Mot de passe',
  'expertRegistration.fields.confirmPassword': 'Confirmer le mot de passe',
  'expertRegistration.fields.companyName': 'Nom de l\'entreprise',
  'expertRegistration.fields.siren': 'SIREN',
  'expertRegistration.fields.siret': 'SIRET',
  'expertRegistration.fields.contactEmail': 'Email de contact',
  'expertRegistration.fields.contactPhone': 'Téléphone de contact',
  'expertRegistration.fields.websiteUrl': 'Site web',
  'expertRegistration.fields.expertiseAreas': 'Domaines d\'expertise',
  'expertRegistration.fields.customExpertise': 'Domaine d\'expertise personnalisé',
  'expertRegistration.fields.specializations': 'Spécialisations',
  'expertRegistration.fields.customSpecialization': 'Spécialisation personnalisée',
  'expertRegistration.fields.certifications': 'Certifications',
  'expertRegistration.fields.customCertification': 'Certification personnalisée',
  'expertRegistration.fields.headquarters': 'Siège social',
  'expertRegistration.fields.headquartersRegion': 'Région',
  'expertRegistration.fields.headquartersDepartment': 'Département',
  'expertRegistration.fields.serviceCoverage': 'Couverture des services',
  'expertRegistration.fields.selectRegions': 'Sélectionner les régions',
  'expertRegistration.fields.selectEUCountries': 'Sélectionner les pays UE',
  'expertRegistration.fields.selectCountries': 'Sélectionner les pays',
  'expertRegistration.fields.remoteServices': 'Services à distance disponibles',
  'expertRegistration.fields.yearsExperience': 'Années d\'expérience',
  'expertRegistration.fields.teamSize': 'Taille de l\'équipe',
  'expertRegistration.fields.languages': 'Langues',
  'expertRegistration.fields.bio': 'Biographie professionnelle',
  'expertRegistration.fields.engagementModels': 'Modèles d\'engagement',
  
  // Placeholders
  'expertRegistration.placeholders.companyName': 'ABC Conseil',
  'expertRegistration.placeholders.search': 'Rechercher...',
  'expertRegistration.placeholders.searchCertifications': 'Rechercher des certifications...',
  'expertRegistration.placeholders.customExpertise': 'ex: Blockchain & Web3',
  'expertRegistration.placeholders.customSpecialization': 'ex: Implémentation IA/ML',
  'expertRegistration.placeholders.customCertification': 'ex: ISO 27001',
  'expertRegistration.placeholders.selectRegion': 'Sélectionner une région',
  'expertRegistration.placeholders.selectDepartment': 'Sélectionner un département',
  'expertRegistration.placeholders.bio': 'Décrivez votre expérience et votre approche...',
  
  // Help texts
  'expertRegistration.help.siren': 'Numéro d\'identification à 9 chiffres',
  'expertRegistration.help.siret': 'Numéro d\'établissement à 14 chiffres',
  'expertRegistration.help.expertiseAreas': 'Sélectionnez {{min}} à {{max}} domaines d\'expertise',
  'expertRegistration.help.specializations': 'Sélectionnez {{min}} à {{max}} spécialisations',
  'expertRegistration.help.certifications': 'Sélectionnez {{min}} à {{max}} certifications',
  'expertRegistration.help.serviceCoverage': 'Sélectionnez toutes les zones de couverture qui s\'appliquent à vos services',
  'expertRegistration.help.profileOptional': 'Ces champs sont facultatifs mais aident les clients à comprendre votre expertise',
  
  // Summary section titles
  'expertRegistration.summary.companyInfo': 'Informations sur l\'entreprise',
  'expertRegistration.summary.expertise': 'Expertise',
  'expertRegistration.summary.certifications': 'Certifications',
  'expertRegistration.summary.geographic': 'Couverture géographique',
  'expertRegistration.summary.professionalProfile': 'Profil professionnel',
  
  // Common
  'expertRegistration.optional': 'facultatif',
  'expertRegistration.years': 'ans',
  
  'expertRegistration.terms.accept': 'J\'accepte les conditions d\'utilisation',
  'expertRegistration.terms.link': 'Voir les conditions',
  
  // Validation
  'expertRegistration.validation.companyNameRequired': 'Le nom de l\'entreprise est requis',
  'expertRegistration.validation.sirenInvalid': 'Le SIREN doit contenir exactement 9 chiffres',
  'expertRegistration.validation.siretInvalid': 'Le SIRET doit contenir exactement 14 chiffres',
  'expertRegistration.validation.emailInvalid': 'Veuillez saisir une adresse email valide',
  'expertRegistration.validation.urlInvalid': 'Veuillez saisir une URL valide',
  'expertRegistration.validation.passwordMin': 'Le mot de passe doit contenir au moins 8 caractères',
  'expertRegistration.validation.passwordUppercase': 'Le mot de passe doit contenir au moins une majuscule',
  'expertRegistration.validation.passwordLowercase': 'Le mot de passe doit contenir au moins une minuscule',
  'expertRegistration.validation.passwordNumber': 'Le mot de passe doit contenir au moins un chiffre',
  'expertRegistration.validation.passwordMismatch': 'Les mots de passe ne correspondent pas',
  'expertRegistration.validation.expertiseRange': 'Veuillez sélectionner entre 3 et 5 domaines d\'expertise',
  'expertRegistration.validation.specializationsRange': 'Veuillez sélectionner entre 2 et 5 spécialisations',
  'expertRegistration.validation.certificationsRange': 'Veuillez sélectionner entre 1 et 10 certifications',
  
  // Success/Error
  'expertRegistration.success.title': 'Inscription réussie !',
  'expertRegistration.success.description': 'Votre profil a été créé avec succès',
  'expertRegistration.error.title': 'Erreur d\'inscription',
  'expertRegistration.error.description': 'Une erreur est survenue lors de l\'inscription',
  
  // Password Strength
  'expertRegistration.passwordStrength.title': 'Exigences du mot de passe',
  'expertRegistration.passwordStrength.minLength': 'Au moins 8 caractères',
  'expertRegistration.passwordStrength.uppercase': 'Une lettre majuscule',
  'expertRegistration.passwordStrength.lowercase': 'Une lettre minuscule',
  'expertRegistration.passwordStrength.number': 'Un chiffre',
  
  // Common
  'common.loading': 'Chargement...',
  'common.back': 'Retour',
  
  // Step 1: Auth
  'expert.auth.emailLabel': 'Email professionnel',
  'expert.auth.emailPlaceholder': 'votre@email.com',
  'expert.auth.passwordLabel': 'Mot de passe',
  'expert.auth.passwordPlaceholder': 'Minimum 6 caractères',
  'expert.auth.confirmPasswordLabel': 'Confirmer le mot de passe',
  'expert.auth.termsLabel': 'J\'accepte les conditions d\'utilisation',
  'expert.auth.termsRequired': 'Vous devez accepter les conditions',
  
  // Step 2: Company Info
  'expert.company.title': 'Informations Entreprise',
  'expert.company.subtitle': 'Renseignez les détails de votre structure',
  'expert.company.nameLabel': 'Nom de l\'entreprise',
  'expert.company.namePlaceholder': 'ABC Conseil',
  'expert.company.nameRequired': 'Le nom de l\'entreprise est requis',
  'expert.company.sirenLabel': 'SIREN (9 chiffres)',
  'expert.company.sirenPlaceholder': '123456789',
  'expert.company.sirenInvalid': 'Le SIREN doit contenir exactement 9 chiffres',
  'expert.company.siretLabel': 'SIRET (14 chiffres)',
  'expert.company.siretPlaceholder': '12345678900012',
  'expert.company.siretInvalid': 'Le SIRET doit contenir exactement 14 chiffres',
  'expert.company.emailLabel': 'Email de contact',
  'expert.company.phoneLabel': 'Téléphone',
  'expert.company.phonePlaceholder': '+33 1 23 45 67 89',
  'expert.company.websiteLabel': 'Site web',
  'expert.company.websitePlaceholder': 'https://www.exemple.fr',
  'expert.company.websiteInvalid': 'Veuillez entrer une URL valide',
  
  // Step 3: Expertise
  'expert.expertise.title': 'Domaines d\'Expertise',
  'expert.expertise.subtitle': 'Sélectionnez vos domaines de compétence (minimum 3)',
  'expert.expertise.areasLabel': 'Domaines d\'expertise principaux',
  'expert.expertise.areasPlaceholder': 'Rechercher un domaine...',
  'expert.expertise.areasMin': 'Sélectionnez au moins 3 domaines',
  'expert.expertise.areasMax': 'Maximum 5 domaines',
  'expert.expertise.specializationsLabel': 'Spécialisations',
  'expert.expertise.specializationsPlaceholder': 'Rechercher une spécialisation...',
  'expert.expertise.specializationsMin': 'Sélectionnez au moins 2 spécialisations',
  'expert.expertise.specializationsMax': 'Maximum 5 spécialisations',
  'expert.expertise.customLabel': 'Précisez (si "Autre" sélectionné)',
  'expert.expertise.customPlaceholder': 'Ex: Blockchain & Web3',
  'expert.expertise.customRequired': 'Veuillez préciser votre domaine',
  'expert.expertise.customMinLength': 'Minimum 3 caractères',
  
  // Step 4: Certifications
  'expert.certifications.title': 'Certifications & Agréments',
  'expert.certifications.subtitle': 'Ajoutez vos certifications professionnelles (minimum 1)',
  'expert.certifications.label': 'Certifications',
  'expert.certifications.placeholder': 'Rechercher une certification...',
  'expert.certifications.min': 'Sélectionnez au moins 1 certification',
  'expert.certifications.max': 'Maximum 10 certifications',
  'expert.certifications.categoryEnergy': 'Énergie & Environnement',
  'expert.certifications.categoryConstruction': 'Construction & BTP',
  'expert.certifications.categoryQuality': 'Qualité & Normes',
  'expert.certifications.categoryFinance': 'Finance',
  'expert.certifications.categoryBusiness': 'Business & Entreprise',
  'expert.certifications.categoryTraining': 'Formation',
  'expert.certifications.categoryEuropean': 'Européen',
  'expert.certifications.categoryOther': 'Autre',
  
  // Step 5: Geographic
  'expert.geographic.title': 'Zone d\'Intervention',
  'expert.geographic.subtitle': 'Définissez votre couverture géographique',
  'expert.geographic.headquartersTitle': 'Siège social',
  'expert.geographic.regionLabel': 'Région du siège',
  'expert.geographic.regionPlaceholder': 'Sélectionnez une région',
  'expert.geographic.regionRequired': 'La région est requise',
  'expert.geographic.departmentLabel': 'Département',
  'expert.geographic.departmentPlaceholder': 'Ex: 75, 92, 93',
  'expert.geographic.coverageTitle': 'Couverture des services',
  'expert.geographic.scopeLabel': 'Portée géographique',
  'expert.geographic.scopeRequired': 'La portée est requise',
  'expert.geographic.regionsLabel': 'Régions couvertes',
  'expert.geographic.regionsPlaceholder': 'Sélectionnez les régions',
  'expert.geographic.departmentsLabel': 'Départements couverts',
  'expert.geographic.departmentsPlaceholder': 'Ex: 75, 92, 93',
  'expert.geographic.remoteLabel': 'Services à distance disponibles',
  'expert.geographic.countriesLabel': 'Pays couverts',
  'expert.geographic.countriesPlaceholder': 'Sélectionnez les pays',
  
  // Step 6: Professional Profile
  'expert.profile.title': 'Profil Professionnel',
  'expert.profile.subtitle': 'Informations complémentaires (optionnel)',
  'expert.profile.experienceLabel': 'Années d\'expérience',
  'expert.profile.experiencePlaceholder': '0-50',
  'expert.profile.teamSizeLabel': 'Taille de l\'équipe',
  'expert.profile.teamSizePlaceholder': '1-1000',
  'expert.profile.languagesLabel': 'Langues parlées',
  'expert.profile.languagesPlaceholder': 'Sélectionnez les langues',
  'expert.profile.bioLabel': 'Biographie / Présentation',
  'expert.profile.bioPlaceholder': 'Décrivez votre expérience et votre approche...',
  'expert.profile.bioMaxLength': 'Maximum 500 caractères',
  'expert.profile.engagementLabel': 'Modèles d\'engagement',
  'expert.profile.engagementHourly': 'Taux horaire',
  'expert.profile.engagementFixed': 'Forfait',
  'expert.profile.engagementSuccess': 'Honoraires de succès',
  'expert.profile.engagementRetainer': 'Mandat',
  'expert.profile.engagementProBono': 'Pro bono',
  
  // Step 7: Summary
  'expert.summary.title': 'Récapitulatif',
  'expert.summary.subtitle': 'Vérifiez vos informations avant de soumettre',
  'expert.summary.companySection': 'Entreprise',
  'expert.summary.expertiseSection': 'Expertise',
  'expert.summary.certificationsSection': 'Certifications',
  'expert.summary.geographicSection': 'Géographie',
  'expert.summary.profileSection': 'Profil Professionnel',
  'expert.summary.edit': 'Modifier',
  'expert.summary.customBadge': 'Personnalisé',
  'expert.summary.headquartersLabel': 'Siège',
  'expert.summary.coverageLabel': 'Couverture',
  'expert.summary.remoteAvailable': 'Services à distance',
  'expert.summary.experienceYears': 'ans d\'expérience',
  'expert.summary.teamMembers': 'membres',
  
  // Success Page
  'expert.success.title': 'Profil conseiller créé avec succès !',
  'expert.success.subtitle': 'Votre demande a été envoyée',
  'expert.success.pendingTitle': 'En attente de vérification',
  'expert.success.pendingDescription': 'Votre profil est en cours de vérification par notre équipe. Vous recevrez un email dans les 48h pour confirmer votre référencement.',
  'expert.success.nextStepsTitle': 'En attendant, vous pouvez :',
  'expert.success.explorePlatform': 'Explorer la plateforme',
  'expert.success.explorePlatformDescription': 'Découvrez comment les utilisateurs recherchent des subventions',
  'expert.success.createUserProfile': 'Créer un profil utilisateur',
  'expert.success.createUserProfileDescription': 'Testez la recherche de subventions pour vos propres projets',
  'expert.success.returnHome': 'Retour à l\'accueil',
  
  // Auth Step
  'expertRegistration.auth.directoryTitle': 'Rejoignez notre annuaire de conseillers',
  'expertRegistration.auth.directoryDescription': 'En complétant cette inscription, vous serez référencé dans notre annuaire de conseillers où des clients potentiels pourront vous trouver et vous contacter pour une assistance en subventions.',
  'expertRegistration.auth.createUserAccount': 'Créer aussi un compte utilisateur pour explorer les subventions',
  'expertRegistration.auth.userAccountBenefit': 'Vous pourrez utiliser la plateforme pour rechercher des subventions pour vous-même ou vos clients',
  
  // Validation Messages
  'expert.validation.required': 'Ce champ est requis',
  'expert.validation.emailInvalid': 'Adresse email invalide',
  'expert.validation.passwordMismatch': 'Les mots de passe ne correspondent pas',
  'expert.validation.passwordTooShort': 'Le mot de passe doit contenir au moins 6 caractères',
  'expert.validation.minSelection': 'Sélection minimum non atteinte',
  'expert.validation.maxSelection': 'Sélection maximum dépassée',
  'expert.validation.urlInvalid': 'URL invalide',
  'expert.validation.phoneInvalid': 'Numéro de téléphone invalide',
  
  // Error Messages
  'expert.error.submissionFailed': 'Erreur lors de la soumission',
  'expert.error.submissionFailedDescription': 'Une erreur s\'est produite. Veuillez réessayer.',
  'expert.error.authFailed': 'Erreur d\'authentification',
  'expert.error.emailAlreadyExists': 'Cet email est déjà utilisé',
  'expert.error.networkError': 'Erreur de connexion. Vérifiez votre connexion internet.',
} as const;
